import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import { RequisitosPruebasInterface } from "../../../../../interfaces/RequisitosPruebasInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const RequisitosPruebasListaPrint = () => {
  const tituloFormulario = "REQUISITOS PARA EL PROCESO DE PRUEBAS DE CONFIANZA";
  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, reset } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryRequisitosPruebas = useGetData<RequisitosPruebasInterface>({
    url: `/requisitos_pruebas/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "requisitos_pruebas"],
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_requisitos_pruebas: fechafg.fecha_requisitos_pruebas || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  useEffect(() => {
    if (queryRequisitosPruebas.data) {
      const requisitosPruebas = queryRequisitosPruebas.data;
      reset({
        calle_rp: requisitosPruebas.calle_rp || "",
        no_rp: requisitosPruebas.no_rp || "",
        cp_rp: requisitosPruebas.cp_rp || "",
      });
    }
  }, [queryRequisitosPruebas.data, reset]);

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg overflow-hidden mt-4 mb-4 relative">
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Contenido del formulario */}
      <div className="p-6 flex flex-col gap-6">
        <h2 className="text-xl font-bold mb-4 text-center">
          REQUISITOS PARA EL PROCESO DE PRUEBAS DE CONFIANZA
        </h2>
        {/* Texto principal */}
        <p className="text-justify text-gray-800 leading-relaxed">
          Presentarse en las oficinas ubicadas en <strong>Calle</strong>{" "}
          {queryRequisitosPruebas.data?.calle_rp} <strong>No.</strong>{" "}
          {queryRequisitosPruebas.data?.no_rp}{" "}
          <strong>Colonia Juárez, Delegación Cuauhtémoc, C.P.</strong>{" "}
          {queryRequisitosPruebas.data?.cp_rp}
          <strong>, Ciudad de México.</strong>
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Para su comodidad los evaluados deberán preferentemente asistir con
          vestimenta casual y con{" "}
          <strong>
            <u>identificación oficial con fotografía</u>
          </strong>
          , y una fotocopia de esta.
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Se requiere que el día de la evaluación, el evaluado presente
          justificante médico, debidamente firmado por el médico tratante
          señalando número de cedula profesional y si padece alguna enfermedad o
          se encuentra tomando algún medicamento, favor de referirlo y presentar
          comprobante médico.
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Con la finalidad de agilizar el proceso y por motivo de espacios se
          recomienda no acudir con acompañantes, mochilas, maletas, bolsas
          voluminosas, equipo de cómputo, etc., se recomienda solo ingresar con
          la documentación requerida, lápiz, pluma, sacapuntas, etc.
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Es necesario,{" "}
          <u>
            que los evaluados{" "}
            <strong>presenten el día de las pruebas de confianza</strong> la
            siguiente documentación, en caso de que no acuda con la
            documentación se dará aviso inmediato a la empresa:
          </u>
        </p>
        <div className="mt-[85px]"></div>
      </div>
      <div className="max-w-4xl mx-auto bg-white overflow-hidden mt-4 mb-4 relative">
        {/* Footer */}
        <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
          <p className="text-white text-xs text-center font-light px-4">
            <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
            Prohibida su reproducción o copia fuera de las instalaciones de
            Skyangel.
          </p>
        </div>
        <ul className="list-disc text-justify text-gray-800 leading-relaxed">
          <li>
            <strong>
              Documentos en original para su cotejo y entrega de copias:
            </strong>
            <br />
            - Acta de nacimiento
            <br />
            - Curriculum vitae, actualizado con fotografía, engrapado y con
            firma autógrafa en cada hoja, detalle su trayectoria laboral de
            empleos formales e infórmales, cursos de capacitación, entregue sin
            engargolar, no agregar constancias ni reconocimientos, solo
            menciónelos.
            <br />- Identificación oficial con fotografía, (Credencial de
            elector, Pasaporte, o Cedula Profesional) (Dos copias) anote con
            letra de molde en las copias y en espacio visible su nombre completo
            iniciando por apellidos en cada uno de ellos y la leyenda que se
            encuentra a continuación
          </li>
        </ul>

        <p className="text-justify text-gray-800 leading-relaxed">
          Bajo protesta de decir verdad, hago constar que la presente fotocopia
          fue tomada del documento original, mismo que cuenta con validez
          oficial y fue expedido por una institución con reconocimiento
          gubernamental. Hago entrega a la empresa SKA TRACKING AND SECURITY
          S.A. de C.V. a los{" "}
          <span>
            <strong>
              {queryFechaFG.data?.fecha_requisitos_pruebas
                ? (() => {
                    const date = new Date(
                      queryFechaFG.data.fecha_requisitos_pruebas
                    );
                    date.setDate(date.getDate() + 1);
                    return date.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    });
                  })()
                : "Fecha no disponible"}
            </strong>
          </span>
        </p>

        <div className="mt-[435px]"></div>

        <p className="text-justify text-gray-800 leading-relaxed">
          <strong>Nombre:</strong> {queryEvaluado.data?.nombre || ""}{" "}
          {queryEvaluado.data?.apellido_paterno || ""}{" "}
          {queryEvaluado.data?.apellido_materno || ""}
          <br />
          <strong>Empresa:</strong>{" "}
          {queryEvaluado.data?.empresa_id?.nombre || ""}
          <br />
          <strong>Puesto:</strong> {queryEvaluado.data?.puesto || ""}
          <div className="mt-[50px]"></div>
          <strong>Firma:</strong> _______________________
        </p>
      </div>
      <div className="max-w-4xl mx-auto bg-white overflow-hidden mt-4 mb-4 relative">
        {/* Footer */}
        <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
          <p className="text-white text-xs text-center font-light px-4">
            <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
            Prohibida su reproducción o copia fuera de las instalaciones de
            Skyangel.
          </p>
        </div>

        <ul className="text-justify text-gray-800 leading-relaxed">
          <li>
            <br />
            - Credencial de la empresa (no aplica para procesos de inicio)
            <br />
            - CURP
            <br />
            - Licencia para conducir, aunque esta vencida si fuera el caso
            <br />- Comprobantes de domicilio en el que habita actualmente,
            mismo en donde, de ser el caso se le realizará la visita
            domiciliaria notificándole con antelación; la documentación
            requerida deberá contar con una antigüedad no mayor a dos meses al
            momento de su entrega. (recibos prediales, agua, gas, televisión de
            paga y estados de cuenta bancaria, no es necesario que aparezca
            Usted como titular) anote con letra de molde y en espacio visible su
            nombre completo iniciando por apellidos en cada uno de ellos y la
            leyenda que se encuentra a continuación
          </li>
        </ul>

        <p className="text-justify text-gray-800 leading-relaxed">
          Bajo protesta de decir verdad hago constar que la presente fotocopia
          fue tomada del documento original, mismo que cuenta con validez
          oficial y fue expedido por institución con reconocimiento
          gubernamental. Hago entrega a la empresa SKA TRACKING AND SECURITY
          S.A. de C.V. a los{" "}
          <span>
            <strong>
              {queryFechaFG.data?.fecha_requisitos_pruebas
                ? (() => {
                    const date = new Date(
                      queryFechaFG.data.fecha_requisitos_pruebas
                    );
                    date.setDate(date.getDate() + 1);
                    return date.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    });
                  })()
                : "Fecha no disponible"}
            </strong>
          </span>
        </p>

        <div className="mt-[415px]"></div>

        <p className="text-justify text-gray-800 leading-relaxed">
          <strong>Nombre:</strong> {queryEvaluado.data?.nombre || ""}{" "}
          {queryEvaluado.data?.apellido_paterno || ""}{" "}
          {queryEvaluado.data?.apellido_materno || ""}
          <br />
          <strong>Empresa:</strong>{" "}
          {queryEvaluado.data?.empresa_id?.nombre || ""}
          <br />
          <strong>Puesto:</strong> {queryEvaluado.data?.puesto || ""}
          <div className="mt-[50px]"></div>
          <strong>Firma:</strong> _______________________
        </p>
      </div>
      <div className="max-w-4xl mx-auto bg-white overflow-hidden mt-4 mb-4 relative">
        {/* Footer */}
        <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
          <p className="text-white text-xs text-center font-light px-4">
            <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
            Prohibida su reproducción o copia fuera de las instalaciones de
            Skyangel.
          </p>
        </div>

        <ul className="text-justify text-gray-800 leading-relaxed">
          <li>
            <br />
            - Último comprobante de pago de las colegiaturas de cada uno de los
            hijos que dependan del evaluado o de su esposa
            <br />
            - Acta de matrimonio o concubinato y/o sentencia de divorcio
            <br />
            - Comprobantes de ingresos, preferentemente de pago de nómina (Dos
            últimos meses)
            <br />
            - Comprobantes de ingresos, preferentemente de pago de nómina (Dos
            últimos meses) de su esposa o cónyuge.
            <br />
            - Constancia de Situación Fiscal
            <br />
            - Dos últimos estados de cuenta de instituciones bancarias, a nombre
            del evaluado o de su esposa y/o cónyuge.
            <br />
            - Dos últimos estados de cuenta de Tiendas departamentales.
            <br />
            - Consulta personal en el buró de crédito (www.burodecredito.com.mx)
            <br />
            - Consulta personal en el círculo de crédito
            (www.circulodecredito.com.mx)
            <br />
            - Dos referencias laborales de sus jefes inmediatos; en una hoja
            anote los siguientes datos: nombre, cargo, empresa, puesto,
            teléfono. Solo aplica para personal que labora (original).
            <br />
            - En caso de que su evaluación sea para incorporarse por primera vez
            a la empresa, presentar dos cartas laborales que indiquen: puesto,
            función, fecha de ingreso y motivo de la renuncia, así como el
            teléfono de la persona que firma, si es números celulares anotar
            también un número fijo.
            <br />
            - Dos referencias personales que no sean de familiares, con los
            siguientes datos: nombre y relación que tiene con usted, tiempo de
            conocerlo, teléfonos de casa y/o trabajo (si es número celulares
            anotar también un número fijo).
            <br />- Certificado de Estudios (último grado concluido) y/o cédula
            profesional (Original) y (2 copias por ambas caras); mismos que
            deberán contar con las siguientes características: ser legibles,
            completos y por ambos lados del documento. Con los datos señalados y
            la siguiente leyenda:
          </li>
        </ul>

        <p className="text-justify text-gray-800 leading-relaxed">
          Bajo protesta de decir verdad hago constar que la presente fotocopia
          fue tomada del documento original, mismo que cuenta con validez
          oficial y fue expedido por institución con reconocimiento
          gubernamental. Hago entrega a la empresa SKA TRACKING AND SECURITY
          S.A. de C.V. a los{" "}
          <span>
            <strong>
              {queryFechaFG.data?.fecha_requisitos_pruebas
                ? (() => {
                    const date = new Date(
                      queryFechaFG.data.fecha_requisitos_pruebas
                    );
                    date.setDate(date.getDate() + 1);
                    return date.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    });
                  })()
                : "Fecha no disponible"}
            </strong>
          </span>
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          <strong>Nombre:</strong> {queryEvaluado.data?.nombre || ""}{" "}
          {queryEvaluado.data?.apellido_paterno || ""}{" "}
          {queryEvaluado.data?.apellido_materno || ""}
          <br />
          <strong>Empresa:</strong>{" "}
          {queryEvaluado.data?.empresa_id?.nombre || ""}
          <br />
          <strong>Puesto:</strong> {queryEvaluado.data?.puesto || ""}
          <div className="mt-[50px]"></div>
          <strong>Firma:</strong> _______________________
        </p>
      </div>
      <div className="max-w-4xl mx-auto bg-white overflow-hidden mt-4 mb-4 relative">
        {/* Footer */}
        <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
          <p className="text-white text-xs text-center font-light px-4">
            <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
            Prohibida su reproducción o copia fuera de las instalaciones de
            Skyangel.
          </p>
        </div>

        <ul className="list-disc text-justify text-gray-800 leading-relaxed">
          <li>
            <strong>Documentación que deberá mostrar en copia</strong>
            <br />
            - Acta de nacimiento de sus dependientes económicos
            <br />
            - Tarjeta de circulación y factura de vehículos particulares
            <br />- Propiedad en bienes inmuebles (escrituras, compra-venta,
            donación, convenio, herencia, testamento, comodato, copropiedad,
            etc)
            <br />
            - Constancia de Situación Fiscal
            <br />- Procedimientos administrativos, procesos penales, carpetas
            de investigación, sanciones, recomendaciones, etc.
            <div className="mt-[50px]"></div>
            En el caso de que usted tenga ingresos por una actividad informal,
            deberá presentar comprobante
            <div className="mt-[415px]"></div>
            <strong>
              Los documentos originales se devolverán una vez cotejados con la
              copia.
            </strong>
          </li>
        </ul>

        <div className="bg-gray-200 p-4 rounded-md border-2 border-black">
          <p className="text-justify text-gray-800 font-bold leading-relaxed">
            La presentación de documentos apócrifos, la falsedad de nombre y de
            su domicilio, se hará del conocimiento a la empresa por la que Usted
            se presenta a realizar las evaluaciones de Pruebas de Confianza.
          </p>
        </div>

        <p className="text-justify text-gray-800 leading-relaxed"></p>
      </div>
      {/* Footer */}
      <div className="bg-customBlue/90 py-2 rounded-b-lg w-full">
        <p className="text-white text-xs text-center font-light px-4">
          <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
          Prohibida su reproducción o copia fuera de las instalaciones de
          Skyangel.
        </p>
      </div>
    </div>
  );
};
